import mapValues from 'lodash/mapValues';
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import agenda from '../../agenda/store/agenda.reducers';
import achievements from '../../core/achievements/achievements.reducers';
import data from '../../core/data/data.reducers';
import users from '../../core/users/users.reducers';
import matching from '../../matching/store/matching.reducers';
import networking from '../../networking/store/networking.reducers';
import participants from '../../participants/store/participants.reducers';
import programs from '../../programs/store/programs.reducers';
import sponsors from '../../sponsors/store/sponsors.reducers';
import workshopSessions from '../../workshop-session/store/workshopSessions.reducers';
import workshops from '../../workshops/store/workshops.reducers';
import { hasOfflineSupport, storagePrefix } from '../offline/offline.helpers';
import appointments from './appointments';
import modalEntries from './modalEntries';
import registrations from './registrations';
import user from './user';

function persist(key: string, reducer: any) {
  const config = {
    version: 1,
    key: `${storagePrefix}/${key}`,
    storage,
  };
  return persistReducer(config, reducer);
}

const reducersToPersist = [
  'achievements',
  'agenda',
  'data',
  'user',
  'users',
  'sponsors',
  'workshops',
  'registrations',
  'appointments',
  'programs',
  'participants',
  'workshopSessions',
];

export default combineReducers(
  mapValues(
    {
      achievements,
      agenda,
      matching,
      data,
      user,
      users,
      sponsors,
      modalEntries,
      workshops,
      registrations,
      appointments,
      programs, // TODO: remove
      participants,
      networking,
      workshopSessions,
    },
    (reducer, key) => {
      if (hasOfflineSupport() && reducersToPersist.includes(key)) {
        return persist(key, reducer);
      }
      return reducer;
    },
  ),
);
